/**
 * Format số tài chính cho dashboard PnL (theo `plan/PBI_Dashboard.md` §4 quy ước):
 * - Số âm → ngoặc đơn `(1,234)` (KHÔNG dấu trừ), trả `neg=true` để UI tô đỏ.
 * - Tiền USD → prefix `$ ` (vd `$ (94,966)`).
 * - Ngăn cách hàng nghìn. Ô trống (null/undefined/'') → để trống.
 * - `signed`: giữ dấu trừ `-47` (cột Change của Market price) thay vì ngoặc.
 */
export interface FmtResult {
  text: string
  neg: boolean
}

const ACCESS_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** Cell ngày → `DD-MMM-YYYY` (Access parity, skill /convert-table §9). Giá trị
 *  không parse được giữ nguyên (vd label tháng "LRCN26"). */
export function fmtDate(v: unknown): string {
  if (v == null || v === '') return ''
  const d = new Date(String(v))
  if (Number.isNaN(d.getTime())) return String(v)
  const day = `${d.getDate()}`.padStart(2, '0')
  return `${day}-${ACCESS_MONTHS[d.getMonth()]}-${d.getFullYear()}`
}

export function fmtNum(
  v: number | null | undefined,
  opts: { currency?: boolean; decimals?: number; signed?: boolean } = {},
): FmtResult {
  if (v == null || (typeof v === 'number' && Number.isNaN(v))) {
    return { text: '', neg: false }
  }
  const { currency = false, decimals = 0, signed = false } = opts
  const neg = v < 0
  const opt = { minimumFractionDigits: decimals, maximumFractionDigits: decimals }
  let body: string
  if (signed) {
    body = v.toLocaleString('en-US', opt) // giữ dấu trừ
  } else {
    const grouped = Math.abs(v).toLocaleString('en-US', opt)
    body = neg ? `(${grouped})` : grouped
  }
  return { text: currency ? `$ ${body}` : body, neg }
}
